import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    url: String,
    target: String
  }
  static targets = ["text", "spinner"]

  async load(event) {
    event.preventDefault()
    const button = event.currentTarget

    // Show loading state
    if (this.hasTextTarget) this.textTarget.classList.add("hidden")
    if (this.hasSpinnerTarget) this.spinnerTarget.classList.remove("hidden")
    button.disabled = true

    try {
      const response = await fetch(this.urlValue, {
        headers: {
          "Accept": "text/html",
          "X-Requested-With": "XMLHttpRequest"
        }
      })

      if (!response.ok) throw new Error("Network response was not ok")

      const html = await response.text()
      const targetElement = document.getElementById(this.targetValue)

      if (targetElement) {
        // Remove the load-more button container
        button.closest("[id^='load-more-']")?.remove()
        // Append new content
        targetElement.insertAdjacentHTML("beforeend", html)
      }
    } catch (error) {
      console.error("Load more failed:", error)
      // Reset button state
      if (this.hasTextTarget) this.textTarget.classList.remove("hidden")
      if (this.hasSpinnerTarget) this.spinnerTarget.classList.add("hidden")
      button.disabled = false
    }
  }
}
